import axios from 'axios';

export default {
    /**
     * 環境のチェック（ステージング用）
     * この情報は、package.jsonで指定されたNODE_ENVによって変わる
     *
     * @return true: ステージング、false: 他環境
     */
    isStaging() {
        return process.env.NODE_ENV === 'staging';
    },
    /**
     * エラーメッセージの表示
     *
     * @param array data レスポンス
     */
    getErrorMessage(data) {
        let error_message = '';
        try {
            if (data.errors) {
                for (var key in data.errors) {
                    error_message += data.errors[key];
                }
                return error_message;
            }

            // 未知のエラーメッセージ
            error_message =
                'システムエラーが発生しました。テクニカルサポートへご連絡ください。';
        } catch (e) {
            error_message =
                'システムエラーが発生しました。テクニカルサポートへご連絡ください。';
        }
        return error_message;
    },
    /**
     * 文字列内にあるハイフンをスラッシュに変換して、返却
     * IE11では、new Dateを利用した変換をする際、スラッシュ区切りだとバグる
     * その為、当メソッドを利用して、ハイフンをスラッシュに変換する必要がある
     *
     * @param {string} value
     */
    convertHyphenToSlash(value) {
        if (value === null) {
            return null;
        }

        if (value.length === 0) {
            return value;
        }

        return value.replace(/-/g, '/');
    },
    /**
     * 現在日時を指定のフォーマットで返却
     * @param string format 返却値のフォーマット（デフォルト：YYYY-MM-DD）
     */
    getDefaultDateTime(format = 'YYYY-MM-DD', date = new Date()) {
        format = format.replace(/YYYY/g, date.getFullYear());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));

        return format;
    },
    /**
     * 指定された時刻を指定のフォーマットで返却
     *
     * @param   format  返却時の形式
     * @param   date    指定の日時（初期値は現在日時）
     */
    getNowHHMMSS(format = 'HH:MM:SS', date = new Date()) {
        format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
        format = format.replace(/MM/g, ('0' + date.getMinutes()).slice(-2));
        format = format.replace(/SS/g, ('0' + date.getSeconds()).slice(-2));

        return format;
    },
    /**
     * 指定日から指定日前の日付を取得
     * デフォルトで前日を返す
     *
     * @param {int} day 何日前
     * @param {Date} date
     * @param {string} format 返却値のフォーマット（デフォルト：YYYY-MM-DD）
     */
    getTheDayBefore(day = 1, date = new Date(), format = 'YYYY-MM-DD') {
        const the_day = new Date(date.getFullYear(), date.getMonth(), date.getDate() - day);
        format = format.replace(/YYYY/g, the_day.getFullYear());
        format = format.replace(/MM/g, ('0' + (the_day.getMonth() + 1)).slice(-2));
        format = format.replace(/DD/g, ('0' + the_day.getDate()).slice(-2));

        return format;
    },
    getLastMonthDateTime() {
        let format = 'YYYY-MM-01';
        let date = new Date();
        if (date.getMonth() == 0) {
            format = format.replace(/YYYY/g, date.getFullYear() - 1);
            format = format.replace(/MM/g, '12');
        } else {
            format = format.replace(/YYYY/g, date.getFullYear());
            format = format.replace(/MM/g, ('0' + date.getMonth()).slice(-2));
        }
        return format;
    },
    /**
     * 渡されたdateの月の最後の日を返却
     */
    getMonthEndDate(date = new Date()) {
        const this_month = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return this.getDefaultDateTime('YYYY-MM-DD', this_month);
    },
    /**
     * 現在当月の最後の日を返却
     */
    getThisMonthEndDate() {
        let date = new Date();
        const this_month = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return this.getDefaultDateTime('YYYY-MM-DD', this_month);
    },
    /**
     * 渡された日時の日に渡された日分を加算して、返却
     *
     * @param string date 対象の日時
     * @param integer addDate 加算する日
     * @param string format 返却値のフォーマット（デフォルト：YYYY-MM-DD）
     */
    getAddDate(date = new Date(), addDate = 1, format = 'YYYY-MM-DD') {
        date.setDate(date.getDate() + addDate);
        format = format.replace(/YYYY/g, date.getFullYear());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));

        return format;
    },
    /**
     * 渡された日時の時に渡された時間を加算して、返却
     *
     * @param string date 対象の日時
     * @param integer addHours 加算する時間
     * @param string format 返却値のフォーマット（デフォルト：YYYY-MM-DD）
     */
    getAddHours(format = 'HH:MM:SS', date = new Date(), addHours = 1) {
        date.setHours(date.getHours() + addHours);
        format = format.replace(/HH/g, ('0' + date.getHours()).slice(-2));
        format = format.replace(/MM/g, ('0' + date.getMinutes()).slice(-2));
        format = format.replace(/SS/g, ('0' + date.getSeconds()).slice(-2));

        return format;
    },
    /**
     * Boolean値をInteger値に変換
     * true -> 1, false -> 0
     *
     * @param boolean value 対象値
     */
    convertBooleanToInteger(value) {
        if (value === true) {
            return 1;
        }
        return 0;
    },
    /**
     * CIDR形式のIPアドレスをアドレス値とサブネットマスクに分割し、返却
     *
     * @param string ip_address IPアドレス
     * @return array 分割後の配列
     */
    separateCidrAddress(ip_address) {
        if (ip_address) {
            let result = ip_address.split('/');
            return { ip_address: result[0], subnet_mask: result[1] };
        }

        return { ip_address: '', subnet_mask: '' };
    },
    /**
     * ページネーション専用メソッド
     * ページごとのインデックスの開始位置を返却
     *
     * @param integer page_size 1ページの表示件数
     * @param integer page_no 現在のページ番号
     * @param integer index 表示している最大Index
     */
    createTableIndex(page_size, page_no, index) {
        return page_size * page_no + index - page_size + 1;
    },
    /**
     * 開始期間を返却
     *
     * @param array date_array Date型の値を格納した配列
     * @return Date date_array[0] 開始期間
     */
    getStartDate(date_array) {
        if (date_array !== null && date_array[0]) {
            return date_array[0] + ' 00:00:00';
        }
        return '';
    },
    /**
     * 終了期間を返却
     *
     * @param array date_array Date型の値を格納した配列
     * @return Date date_array[1] 終了期間
     */
    getEndDate(date_array) {
        if (date_array !== null && date_array[1]) {
            return date_array[1] + ' 23:59:59';
        }
        return '';
    },

    /**
     * 終了期間を返却
     *      最終日の最後の時間なので23:59:59を付く
     *
     * @param string date
     * @return Date
     */
    formatSearchEndDate(date) {
        if (date) {
            return date + ' 23:59:59';
        }
        return '';
    },

    /**
     * 一つの期間を返却
     *
     * @param string start_date Date型の値を格納した文字列
     * @return Date search_start_date 検索期間
     */
    getSingleStartDate(start_date) {
        if (start_date) {
            return start_date + ' 00:00:00';
        }
        return '';
    },
    /**
     * 一つの終了期間を返却
     *
     * @param string end_date Date型の値を格納した文字列
     * @return Date search_end_date 検索期間
     */
    getSingleEndDate(end_date) {
        if (end_date) {
            return end_date + ' 23:59:59';
        }
    },
    /**
     * 期間を返却
     *
     * @param string date 日付
     * @return string 整形した日付
     */
    getDate(date) {
        if (date) {
            return date + ' 00:00:00';
        }
        return '';
    },
    /**
     * 終了期間を返却
     *  期間の最終日の最後の時間を付ける
     *
     * @param string date 日付
     * @return string 終了期間
     */
    getSingleEndDate(date) {
        if (date) {
            return date + ' 23:59:59';
        }
        return '';
    },
    /**
     * 配列の要素が一つでも、空orNullだったかチェックを行い、結果を返却
     *
     * @param array array_value 対象配列
     */
    isEmptyOrNullForArrayValue(array_value) {
        let result = false;
        // 一つでも空orNullの要素が合った場合、途中でループを抜けたい為、
        // コールバック関数がtrueを返すと即座にtrueを返すという特性を利用するため、この形にしました。
        result = array_value.some(function(value) {
            if (!value) {
                return true;
            }
        });

        // 上記のsome関数で、trueが返却された = 空orNullだった要素があったことになるので、
        // その結果は反転して返却しています（true: 全要素に値が入っていた、false: 空orNullだった要素があった）
        return !result;
    },
    /**
     * ダウンロード処理
     *
     * @param object vue Vueオブジェクト
     * @param string url リクエストURL
     * @param array request_parameter リクエストパラメータ
     */
    downloadData(vue, url, request_parameter) {
        vue.is_loading = true;

        axios
            .get(url, { params: request_parameter })
            .then(response => {
                let type = 'error';
                if (response.data.status) {
                    type = 'success';
                    if (!response.data.delayed_batch) {
                        location.href =
                            '/common/api/download/' + response.data.file_name;
                    }
                }
                vue.$message({
                    type: type,
                    showClose: true,
                    message: response.data.message
                });

                vue.is_loading = false;
            })
            .catch(error => {
                vue.$message.error({ showClose: true, message: this.getErrorMessage(error.response.data) });
                vue.is_loading = false;
            });
    },
    /**
     * ダウンロード処理
     *
     * @param object vue Vueオブジェクト
     * @param string url リクエストURL
     * @param array request_parameter リクエストパラメータ
     */
    downloadDataByPost(vue, url, request_parameter) {
        vue.is_loading = true;

        axios
            .post(url, request_parameter)
            .then(response => {
                let type = 'error';
                if (response.data.status) {
                    type = 'success';
                    if (!response.data.delayed_batch) {
                        location.href =
                            '/common/api/download/' + response.data.file_name;
                    }
                }
                vue.$message({
                    type: type,
                    showClose: true,
                    message: response.data.message
                });

                vue.is_loading = false;
            })
            .catch(error => {
                vue.$message.error({ showClose: true, message: this.getErrorMessage(error.response.data) });
                vue.is_loading = false;
            });
    },
    /**
     * HTMLメール本文をテキストメール本文に変換する
     *
     * @param string mail_body 変換前のHTMLメール本文
     * @param boolean old_editor_flag 旧エディタ使用フラグ
     * @return string 変換後のテキストメール本文
     */
    convertHtmlToText(mail_body, old_editor_flag) {
        if (mail_body.length > 0) {
            mail_body = mail_body.replace(/<head.*[\s\S]*head>/ig, ''); // ヘッドタグ削除
            mail_body = mail_body.replace(/<a.+?\r?\n(\r?\n)*<\/a>\r?\n/igm, '\n'); // </a>改行<a>を単一の空行に変換
            mail_body = mail_body.replace(/<a\s+(?:[^>]*?\s+)?href=(?:(['"])(?:\\[\s\S]|(?!\1)[\s\S])*?\1[^>]*?)?>\s*<\/a>/gi, ''); // aタグの中身がない場合は削除（例: <a href="https://hoge.com"></a>
            // aタグのhrefと囲まれたspanタグのテキストを取得して改行して返却
            mail_body = mail_body.replace(/<a.*?href=['"]([^'"]+?)['"].*?>([\s\S]+?)<\/a>/ig, (match, p1, p2) => {
                let text = p2.replace(/<span.*?>([\s\S]+?)<\/span>/ig, "$1");
                // リンク先URLとリンク元テキストが同じURLの場合は、リンクのみ返却
                if (text === p1) {
                    return p1;
                } else {
                    return text + "\n" + p1;
                }
            });
            mail_body = mail_body.replace(/<a.*?href=['"]([^'"]+?)['"].*?>([\s\S]+?)<\/a>/ig, "$1 "); // リンクテキスト
            mail_body = mail_body.replace(/<--.*?-->/gm, ''); // コメント削除
            mail_body = mail_body.replace(/<img.*?>/ig, ''); // 画像タグ削除
            mail_body = mail_body.replace(/^\s+|\s+$/g, ''); // 前後の空白文字を削除
            mail_body = mail_body.replace(/\t/g, ''); // 前後の空白文字を削除
            mail_body = mail_body.replace(/^<p[^>]*>\r?\n/i, ''); // <p>タグのみの行を削除
            mail_body = mail_body.replace(/^<\/p>\r?\n(\r?\n)*<p[^>]*>\r?\n/igm, '\n'); // </p>改行<p>を単一の空行に変換
            mail_body = mail_body.replace(/<\/p>(<p[^>]*>)?/igm, '\n'); // </p><p>と</p>を改行に変換
            mail_body = mail_body.replace(/^<\/?p>/ig, ''); // </p>タグを削除
            mail_body = mail_body.replace(/<\/div>(<div[^>]*>)?/igm, '\n'); // </div><div>と</div>を改行に変換
            mail_body = mail_body.replace(/<br( \/)?>/ig, '\n'); // それ以外の<br>は単独で改行1つに置き換える
            mail_body = mail_body.replace(/<\/?[^>]+>/ig, ''); // その他のHTMLタグを削除
            mail_body = mail_body.replace(/&#[0-9]+;/g, '\n'); // ディバイダを変換した際のタグを改行に変換 念の為同様の要素があれば改行に変換
            mail_body = mail_body.replace(/&amp;amp;/g, '&'); // &amp;amp;を&に変換 ボタンとソーシャルアイコンがダウブルエスケープされる変換
            mail_body = mail_body.replace(/&amp;/g, '&'); // &amp;を&に変換
            mail_body = mail_body.replace(/&lt;/g, '<'); // &lt;を<に変換
            mail_body = mail_body.replace(/&gt;/g, '>'); // &gt;を>に変換
            mail_body = mail_body.replace(/&quot;/g, '"'); // &quot;を"に変換
            mail_body = mail_body.replace(/&#39;/g, "'"); // &#39;を'に変換
            mail_body = mail_body.replace(/&#x27;/g, "'"); // &#x27;を'に変換
            mail_body = mail_body.replace(/&#160;/g, ""); // &#x160;を空白に変換
            mail_body = mail_body.replace(/^\s+|\s+$/g, ''); // 前後の空白文字を削除
            mail_body = mail_body.replace(/\s{2,}?/g, "\n"); // 連続した空白文字は１つの改行に変換
            mail_body = mail_body.replace(/[\r\n]{2,}/g, "\n\n"); // 空行が複数連続する場合は1行にまとめる
            mail_body = mail_body.replace(/&nbsp;/g, ""); // &nbsp;を削除
            mail_body = mail_body.replace(/&copy;/g, ""); // &copy;を削除

            //bee plugin表示時のみ
            if (!old_editor_flag) {
                // bee pluginのテキストコンテンツの改行を変更
                mail_body = mail_body.replace(/<\/p>/ig, '\n');
                mail_body = mail_body.replace(/<br data-mce-bogus="1" \/>/ig, '\n');
            }
            //bee pluginのメディアクエリを削除
            if (mail_body.match('@media')) {
                mail_body = mail_body.replace(/@media([\s\S]*)\}\s*\}/g, "");
                mail_body = mail_body.replace(/[\r\n]+/, "");
            }
        }
        return mail_body;
    },
    /**
     * テキストメール本文をHTMLメール本文に変換する
     *
     * @param string mail_body_text 変換前のテキストメール本文
     * @return string 変換後のHTMLメール本文
     */
    convertTextToHtml(mail_body_text) {
        if (mail_body_text.length > 0) {
            mail_body_text = this.revertEscapedAmpersand(mail_body_text);
            mail_body_text = mail_body_text.replace(/(https?:\/\/([\w-]+\.)+[\w-]+([\w-.\/?%&=#{}!]*)?)/ig, "<a href='$1'>$1</a>"); // urlをaタグで囲む
            mail_body_text = mail_body_text.replace(/{!unsubscribe_page_(ja|en|cn|tw|kr)}/ig, "<a href='$&'>$&</a>");
            mail_body_text = mail_body_text.replace(/\n/g, '<br>\n'); // 改行を<br>に変更
        }
        return mail_body_text;
    },
    /**
     * 連想配列にnullが入っていた場合、空文字に変換する
     *
     * @param array array 変換前の配列
     * @return array 変換後の配列
     */
    convertNullToEmptyByArray(array) {
        let converted_array = {};
        for (let key in array) {
            converted_array[key] = '';
            if (array[key] !== null) {
                converted_array[key] = array[key];
            }
        }
        return converted_array;
    },
    /**
     * 渡された値にnullが入っていた場合、空文字を返却する
     *
     * @param mixed value 変換前の値
     * @return string 空文字または変換前の値
     */
    convertNullToEmpty(value) {
        if (value === null) {
            return '';
        }

        return value;
    },
    /**
     * 空文字のみで構成されている文字列かチェックする
     * ※クロスブラウザ対応として、trim()ではなく、replaceで対応してます
     *
     * @param string target_string 対象の文字列
     * @return boolean true: ブランクだった、false: なにかしらの文字が含まれている
     */
    isBlankString(target_string) {
        // 渡された値がNULLだった場合
        if (target_string === null) {
            return true
        }

        // 渡された文字列が空だった場合
        if (target_string.length === 0) {
            return true;
        }

        // クロスブラウザ対応として、trim()ではなく、replaceで対応してます
        let after_string = target_string.replace(/^\s+|\s+$/g, '');
        // replaceした結果、空だった場合
        if (after_string.length === 0) {
            return true;
        }

        return false;
    },
    /**
     * アップロード有効なファイル名か判別する
     * 有効: 半角の英数字記号のみ
     *
     * @param string file_name
     * @return boolean true: 無効なファイル名, false: 有効なファイル名
     */
    isInvalidUploadFileName(file_name) {
        return file_name.match(/^[a-zA-Z0-9()'&$%~!#@_.=-]+$/) === null;
    },
    /**
     * 送信者ドメイン追加要望フォームのURLを取得
     * クライアントIDをパラメータとしてセットする
     *
     * @param {integer} client_id
     * @return string
     */
    getFormUrlOfAddSenderDomain(client_id) {
        return `https://innovation.lmsg.jp/form/10003/dKbhAUul?client_id=${client_id}`;
    },
    /**
     * 企業情報変更要望URLの取得
     * クライアントIDをパラメータとしてセットする
     *
     * @return string
     */
    getFormUrlOfChangeCompanyInformation(client_id) {
        return `https://innovation.lmsg.jp/form/10003/ayx5Lhmw?client_id=${client_id}`;
    },
    /**
     * 配信完了状態のメール配信ステータス(46)を取得
     * @return integer 46: finish,配信完了
     */
    getMailDeliveryStatusFinished() {
        return 46;
    },
    /**
     * 指定したパスの画面から開かれたタブであるか確認
     *
     * @param {object} opener_object
     * @param {string} path
     * @return {boolean}
     */
    isOpenedFromSpecifiedPath(opener_object, path) {
        return opener_object !== null && opener_object.location.pathname.match(path) !== null;
    },
    /**
     * ひらがなをカタカナに変換して返却
     *
     * @param {string} text
     * @return {string}
     */
    convertKana(text) {
        return text.replace(/[\u3041-\u3096]/g, match => {
            const character = match.charCodeAt(0) + 0x60;
            return String.fromCharCode(character);
        });
    },
    /**
     * 送信者名とメールアドレスを初期設定し、Vuexに保存
     *
     * @param object vue Vueオブジェクト
     */
    resetSenderInformation(vue) {
        vue.$store.commit('components/sender_list/resetNameEmail');
        vue.$store.commit('components/sender_list/resetDefaultNameEmail');
    },
    /**
     * vuexに送信者の情報を保存
     *
     * @param object vue Vueオブジェクト
     * @param object sender_information 送信者の情報
     */
    saveSenderInformation(vue, sender_information) {
        vue.$store.commit('components/sender_list/setNameEmail', sender_information);
    },
    /**
     * vuexに送信者のデフォルト情報を保存
     *
     * @param object vue Vueオブジェクト
     * @param object default_information
     */
    saveDefaultSenderInformation(vue, default_information) {
        vue.$store.commit('components/sender_list/setDefaultNameEmail', default_information);
    },
    /**
     * デフォルト件名を整形する
     *
     * @param {string} default_subject
     * @param {string} item_name
     */
    formatDefaultMailSubject(default_subject, item_name) {
        return default_subject + '（' + item_name + '）';
    },
    /**
     * 対象のスクロール位置を初期化
     * 対象を増やす場合は、このメソッドに順次追加する。
     */
    initializeScrollPosion() {
        var target_list = $('.el-table__body-wrapper');
        var length = target_list.length;
        for (var i = 0; i < length; i++) {
            // x, y 座標のスクロールを初期化
            target_list[i].scrollTop = 0;
            target_list[i].scrollLeft = 0;
        }
    },
    /**
     * HTMLの&を&amp;にエスケープする
     * &amp;と&nbsp;以外の&を&amp;に変換する
     */
    escapeAmpersand(target) {
        return target.replace(/&(?!(amp;|nbsp;))/g, '&amp;');
    },
    /**
     *  ダブルエスケープされた&とエスケープされた&を　＆に変換する
     */
    revertEscapedAmpersand(target) {
        let converted_target = target.replace(/&amp;amp;/g, '&'); // &amp;amp;を&に変換 ボタンとソーシャルアイコンがダウブルエスケープされる変換
        return converted_target.replace(/&amp;/g, '&'); // &amp;を&に変換
    },
    /**
     *
     * エスケープされた < と > を　< と > に変換する
     */
    revertEscapedLessAndGreaterThan(target) {
        if (target == null) {
            return target; // nullの場合、処理をスキップする
        }
        let converted_target = target.replace(/&lt;/g, '<'); // &lt;を<に変換
        return converted_target.replace(/&gt;/g, '>'); // &gt;を>に変換
    },
    /**
     * 小数点の項目に対してソートをかける
     */
    sortByFloat(column_name) {
        return (a, b) => Number(a[column_name]) - Number(b[column_name]);
    },
    /**
     * 現在のURLのdomainを得る
     */
    getDomain() {
        let domain = window.location.hostname;
        let domains = domain.split('.');
        if (domains[0]) {
            return domains[0];
        }
        return window.location.hostname;
    },
    /**
     * 現在のURLのdomainがuserかどうか
     */
    isDomainUser() {
        return  (this.getDomain() === 'user');
    },
    /**
     * 現在のURLのdomainがsupportかどうか
     */
    isDomainSupport() {
        return  (this.getDomain() === 'support');
    },
    /**
     * 現在のURLのdomainがadminかどうか
     */
    isDomainAdmin() {
        return  (this.getDomain() === 'admin');
    },
    /** 文字列かどうかチェック
     *
     * @param   mixed   value   対象値
     * @returns boolean         true: String, false: String 以外
     */
    isString(value) {
        return (typeof (value) === "string")
    }
};
